<template>
  <div class="IntellectualPropertyFrom">
    <div class="form_wrap">
      <span class="title">知识产权情况</span>
      <span class="tips"> <img class="icon_tips2" src="@/assets/img/icon_tips2.png" alt />列清主要知识产权名称 </span>

      <div class="btn_wrap">
        <img src="@/assets/img/btn_add.png" alt @click="add()" />
        <img src="@/assets/img/btn_delete.png" alt @click="remove" />
      </div>
      <table>
        <tbody>
          <tr>
            <th width="40px">
              <el-checkbox v-model="allCheck"></el-checkbox>
            </th>
            <th><label class="start">*</label>涉及知识产权</th>
            <th><label class="start">*</label>权利状态</th>
            <th><label class="start">*</label>相关附件</th>
          </tr>
          <tr v-for="(item, index) in PropertyList" :key="index">
            <td>
              <el-checkbox v-model="item.check"></el-checkbox>
            </td>
            <td>
              <el-input v-model="item.PropertyName" :disabled="!auditStatus"></el-input>
            </td>
            <td>
              <el-select v-model="item.PropertyState" placeholder="请选择" :disabled="!auditStatus">
                <el-option v-for="item in PropertyStateList" :key="item.value" :label="item.text" :value="item.value"></el-option>
              </el-select>
            </td>
            <td style="text-align: left">
              <el-upload
                class="upload_style"
                style="margin-left: 6px; padding-bottom: 6px"
                action="/SupplierLogin/UploadProductFile"
                :on-success="handleSuccess"
                :before-remove="beforeRemove"
                :on-remove="handleRemove"
                :before-upload="handleBeforeUpload"
                :on-preview="handleDownLoad"
                :file-list="item.fileList"
                :auto-upload="true"
                :headers="headers"
                :data="{ id: index }"
                :disabled="!auditStatus"
                multiple
                accept="application/pdf"
                :http-request="uploadSectionFile"
              >
                <el-button size="mini" type="primary"> <i class="el-icon-plus"></i>添加上传 </el-button>
              </el-upload>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    IntellectualPropertyList: Array,
    auditStatus: {
      type: Boolean,
      default: true
    },
    PropertyStateList: Array
  },
  data() {
    return {
      allCheck: '',
      PropertyList: [],
      iserror: true,
      Property: {
        check: false,
        PropertyName: '',
        PropertyState: '',
        fileList: []
      }
    }
  },
  watch: {
    allCheck(val) {
      this.PropertyList.forEach((element) => {
        if (element.hasOwnProperty('check')) {
          element.check = val
        }
      })
    },

    IntellectualPropertyList(val) {
      if (!this.IntellectualPropertyList || this.IntellectualPropertyList.length == 0) {
        this.PropertyList.push(this.Property)
      } else {
        this.PropertyList = this.IntellectualPropertyList
      }
    }
  },
  mounted() {
    // console.log(this.IntellectualPropertyList)
    // if (!this.IntellectualPropertyList ||this.IntellectualPropertyList.length==0 ) {
    //   this.PropertyList.push(this.Property);
    // } else {
    //   this.PropertyList = this.IntellectualPropertyList;
    // }
  },
  methods: {
    add() {
      var obj = {
        check: false,
        PropertyName: '',
        PropertyState: '',
        fileList: []
      }
      this.PropertyList.push(obj)
    },
    remove() {
      this.PropertyList = this.PropertyList.filter((item) => {
        return !item.check
      })
    },

    ruleList() {
      console.log(this.PropertyList)
      this.iserror = true
      if (this.PropertyList.length == 0) {
        this.$message.error('请填写知识产权情况！')
        this.iserror = false
        return false
      }

      this.PropertyList.forEach((item) => {
        console.log(item.PropertyState)
        if (!item.PropertyName && this.iserror) {
          this.$message.error('请填写涉及知识产权')
          this.iserror = false
          return false
        }
        if (!item.PropertyState && this.iserror) {
          this.$message.error('请选择(' + item.PropertyName + ')知识产权状态')
          this.iserror = false
          return false
        }
        if (item.PropertyState == 2 && item.fileList.length == 0 && this.iserror) {
          this.$message.error('请上传(' + item.PropertyName + ')知识产权相关附件')
          this.iserror = false
          return false
        }
      })
    },
    handleDownLoad(file) {
      let token = window.localStorage.getItem('loginToken')
      token = token.replace(/\+/g, '%2B')
      this.downloadfile(this.baseURL + 'SupplierLogin/DownLoadFile?fileId=' + file.id + '&remark=' + file.remark + '&token=' + token + '&fileName=' + file.name)
    },
    handleSuccess(response, file, fileList) {
      window.console.log(response, file, fileList)
    },
    handleBeforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (testmsg !== 'pdf' && testmsg !== 'PDF') {
        this.$message.error('请上传pdf文件!')
        return false
      }
      if (file.size > 200 * 1024 * 1024) {
        this.$message.error('请上传小于200M的文件！')
        return false
      }
    },
    beforeRemove(file) {
      let isDelete = true
      if (file && file.status === 'success') {
        isDelete = this.$confirm(`确定删除 ${file.name}？`)
      }
      return isDelete
    },
    handleRemove(file, fileList) {
      var vm = this
      if (file && file.status === 'success') {
        if (file.id == 0) {
          vm.$message({ type: 'success', message: '删除成功!' })
          vm.PropertyList.forEach((item) => {
            item.fileList = item.fileList.filter(function (item1) {
              return item1.remark != file.remark
            })
          })
        } else {
          vm.postRequest('SupplierLogin/DeleteProductFile?fileId=' + file.id).then(function (res) {
            if (res.data.errcode === 0) {
              vm.$message({ type: 'success', message: '删除成功!' })
              vm.PropertyList.forEach((item) => {
                item.fileList = item.fileList.filter(function (item1) {
                  return item1.id != file.id
                })
              })
            } else vm.$message.error('删除失败')
          })
        }
      }
    },
    uploadSectionFile(params) {
      const file = params.file
      var data = new window.FormData()
      data.append('file', file)
      this.uploadFileRequest('SupplierLogin/UploadFile', data).then((res) => {
        if (res.data.errcode == 0) {
          var file = {
            id: res.data.fileid,
            name: res.data.filename,
            remark: ''
          }
          if (this.PropertyList[params.data.id].fileList.length == 0) {
            var fileList = [
              {
                id: res.data.fileid,
                name: res.data.filename,
                remark: ''
              }
            ]
            this.PropertyList[params.data.id].fileList = fileList
          } else {
            this.PropertyList[params.data.id].fileList.push(file)
          }
          // console.log(this.PropertyList)
          params.onSuccess()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.operation {
  align-items: center;

  .files {
    position: relative;
    flex: 1;
    .oText {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      line-height: 23px;
      cursor: pointer;
    }
    input {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      opacity: 0;
      cursor: pointer;
    }
  }
  .template {
    flex: 1;
  }
}
.link {
  cursor: pointer;
}
.filename {
  cursor: pointer;
  white-space: nowrap;
  width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  color: #0066cc;
}

.filename2 {
  width: auto;
}
.tips {
  font-size: 14px;
  color: #ff6600;
}
.icon_tips2 {
  margin-right: 3px;
  margin-left: 6px;
  vertical-align: bottom;
}
// .filedate{width:65%}
// .custom_date ::v-deep.el-date-editor {
//   width: 49% !important;
// }
.custom_date ::v-deep.el-range-editor {
  width: 100% !important;
}
.custom_daterange ::v-deep.el-range-input {
  height: 34px;
  line-height: 34px;
  font-size: inherit;
}
.custom_daterange ::v-deep.el-date-editor {
  height: auto;
}
.datepicker_wrap {
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 3px;
}
.datepicker_wrap ::v-deep.el-input__inner {
  border: none !important;
  border-radius: 4px;
  background: #fff;
}
.filedate2 ::v-deep.el-input__prefix {
  .el-icon-date {
    position: relative;
  }
  .el-icon-date:before {
    content: '';
    width: 4px;
    height: 1px;
    position: absolute;
    top: 50%;
    left: 0;
    background: #303133;
    clear: both;
  }
}
.filedate2 ::v-deep.el-input__inner {
  padding-left: 24px !important;
}
.filedate2 ::v-deep.el-input__prefix {
  left: -4px;
}
.filedate1 ::v-deep.el-input__prefix {
  left: -3px;
}
.filedate1 ::v-deep.el-input__inner {
  padding-left: 40px !important;
  padding-right: 40px !important;
  text-align: center;
}
.filedate1 ::v-deep.el-input__icon {
  line-height: 33px;
}
.start {
  vertical-align: middle;
  color: #f56c6c;
  display: inline-block;
  margin-right: 4px;
}
</style>
